/** Must match `ContextService::CLIENT_CONTEXT_IRI_HEADER` on the API. */
export const COMMUNO_CONTEXT_IRI_HEADER = 'X-Communo-Context-Iri'

export const getStoredContextIri = (): string | null => {
  if (typeof window === 'undefined') {
    return null
  }
  return localStorage.getItem('contextIri')
}

export const withContextRequestHeader = (
  headers: Record<string, string>
): Record<string, string> => {
  const contextIri = getStoredContextIri()
  if (!contextIri) {
    return headers
  }

  return {
    ...headers,
    [COMMUNO_CONTEXT_IRI_HEADER]: contextIri,
  }
}
